/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 8304965989f5
 */

import * as z from "zod";

export type DeleteFolderResponse = { deleted: Array<string> };

export const DeleteFolderResponse$zodSchema: z.ZodType<DeleteFolderResponse> = z
  .object({
    deleted: z.array(z.string()).describe("List of deleted folder paths."),
  });
